import Api from 'App/api'

export const login = Api.post({
  controller: 'user',
  action: 'login',
})

export const renewSession = Api.get({
  controller: 'user',
  action: 'renewToken',
})

export const getLeaseData = Api.get({
  controller: 'user',
  action: 'getPropertyAssociations',
})

export const requestPasswordReset = Api.post({
  controller: 'user',
  action: 'resetPassword',
})

export const validateResetCode = Api.post({
  controller: 'user',
  action: 'validateResetPasswordCode',
})

export const updatePassword = Api.post({
  controller: 'user',
  action: 'updatePassword',
})

export const verifyPassword = Api.post({
  controller: 'user',
  action: 'verifyPassword',
})

export const updateProfilePassword = Api.post({
  controller: 'user',
  action: 'updatePassword',
  forceBaseUrl: 1,
})

// enrollment
export const getEnrollmentSettings = Api.get({
  controller: 'user',
  action: 'getEnrollSettings',
})

export const enrollUser = Api.post({
  controller: 'user',
  action: 'enroll',
})

export const propertyBranding = Api.get({
  controller: 'property',
  action: 'getBranding',
})

export const confirmContact = Api.post({
  controller: 'user',
  action: 'redirectDedupeCustomer',
})

export const verifyToken = Api.post({
  controller: 'user',
  action: 'verifyToken',
})

export const createPassword = Api.post({
  controller: 'user',
  action: 'createPassword',
})

export const sendResetPassword = Api.post({
  controller: 'tenant_users',
  action: 'resetPassword',
  forceBaseUrl: 1,
})

export const logLoginActivity = Api.post({
  controller: 'user',
  action: 'logLoginActivity',
})

export const generateOtp = Api.post({
  controller: 'user',
  action: 'generateOtp',
})

export const otpLogin = Api.post({
  controller: 'user',
  action: 'otpLogin',
})

export const generateToken = Api.post({
  controller: 'user',
  action: 'setTokenCookie',
})

export const userLogout = Api.post({
  controller: 'user',
  action: 'logout',
})
